exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selected-filter[data-v-244051bc] {\n    line-height: 20px;\n    margin-top: 10px;\n}\nth[data-v-244051bc] {\n    font-style: normal;\n}\ntr[data-v-244051bc] {\n    cursor: pointer;\n}\ntr.search-history__row_disabled[data-v-244051bc]:hover {\n    background: transparent;\n}\ntbody td[data-v-244051bc] {\n    font-size: 12px;\n}\n.search-history__row_disabled[data-v-244051bc] {\n    color: #555;\n    cursor: default;\n}\ntd div p[data-v-244051bc] {\n    margin: 0;\n    padding: 0;\n    line-height: normal;\n}\ntable.uk-table.uk-table-hover[data-v-244051bc] {\n    margin: 15px;\n}\n", ""]);

// exports
